module.exports = __webpack_public_path__ + "static/media/landing-mockup.e4e1334f.png";